import Vue from 'vue'
import Router from 'vue-router'
import{Loading,Message} from'element-ui'
/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
// 模板
const Index = () => import('@/page/index') 

const Module = () => import('@/page/module') 
Vue.use(Router)

// export default new Router({
const router =  new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      meta:{
        title:'模板',
      },
      component: Index,
      children:[
        {
          path: '/module',
          name: 'module',
          meta:{
            title:'模板',
          },
          component: Module,
        }
      ]
    },
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js